import { fetchProjects } from "../../services/fetchProjects";
import { useEffect, useState } from "react";
import * as siIcons from "react-icons/si";
import { Link } from "react-router-dom";
import Curve from "../../curve";

const Project = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const data = await fetchProjects();
        // console.log(data);
        setProjects(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Curve>
      <header className="hero">
        <h1 className="hero-heading">
          collection of <span className="primary-color">projects</span>
        </h1>
      </header>
      {loading ? (
        <p className="section">loading projects...</p>
      ) : (
        projects.map(
          (
            {
              id,
              projectTitle,
              projectBrief,
              technologies,
              codeUrl,
              liveUrl,
              createdDate,
            },
            index
          ) => (
            <section
              className={`section ${index % 2 === 0 ? "section-ow" : ""}`}
              key={id}
            >
              <div className="container container-center">
                <h1>{projectTitle}</h1>
                <small>{createdDate}</small>
                <p>{projectBrief}</p>
                <p>
                  {technologies.map((tech, index) => {
                    const IconElement = siIcons[tech];
                    return (
                      <span
                        key={tech}
                        style={{ display: "inline-flex", alignItems: "center" }}
                      >
                        <IconElement size={24} />
                        {technologies.length - 1 === index ? "" : "----"}
                      </span>
                    );
                  })}
                </p>
              </div>
              <Link to={liveUrl} className="link link-primary" target="_blank">
                View Live
              </Link>
              <Link
                to={codeUrl}
                className="link link-secondary"
                target="_blank"
              >
                Source Code
              </Link>
            </section>
          )
        )
      )}
    </Curve>
  );
};

export default Project;
